/**
 * 统一媒体地址：兼容 /storage、反斜杠、相对路径
 * 生产环境用 VUE_APP_API_BASE 拼接；并纠正库内残留的本机绝对地址
 */
const API_BASE = String(process.env.VUE_APP_API_BASE || '').replace(/\/+$/, '')

export function mediaUrl(url) {
  if (!url) return ''
  let u = String(url).trim()
  if (!u) return ''
  u = u.replace(/\\/g, '/')

  if (API_BASE && /^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?/i.test(u)) {
    return u.replace(/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?/i, API_BASE)
  }

  if (/^(https?:|data:|blob:)/i.test(u)) return u

  if (u.startsWith('//')) {
    if (typeof window !== 'undefined' && window.location) {
      return window.location.protocol + u
    }
    return 'https:' + u
  }

  if (!u.startsWith('/')) u = '/' + u

  if (API_BASE && (/^\/(storage|static|uploads)\b/i.test(u))) {
    return API_BASE + u
  }
  return u
}

export function mediaList(list) {
  if (!Array.isArray(list)) return []
  return list.map(mediaUrl).filter(Boolean)
}

export function apiBase() {
  return API_BASE
}
